//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CellComponent",
  props: {
    // 标题名称
    title: {
      type: String,
      required: true,
    },
    // 标题类型 header:标题 text:普通文本 select:带有箭头选项样式 list-header
    type: {
      type: String,
      default: "text",
    },
    icon: {
      type: String,
      default: "right",
    },
  },
  methods: {
    /**
     * cell 中文案区域点击事件
     */
    itemClick() {
      this.$emit("click");
    },
  },
  computed: {
    iconClass() {
      return { [this.icon]: true };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/cell/Index.vue